const accessMaster = {


    COUNTRY_LIST: {
        path: '/country-list'
    },

    ADD_COUNTRY: {
        path: '/create-country'
    },

    UPDATE_COUNTRY: {
        path: '/edit-country'
    },


    STATE_LIST: {
        path: '/state-list'
    },

    ADD_STATE: {
        path: '/create-state'
    },

    UPDATE_STATE: {
        path: '/edit-state'
    },


    DISTRICT_LIST: {
        path: '/district-list'
    },

    ADD_DISTRICT: {
        path: '/create-district'
    },

    UPDATE_DISTRICT: {
        path: '/edit-district'
    },


    TEHSIL_LIST: {
        path: '/tehsil-list'
    },

    ADD_TEHSIL: {
        path: '/create-tehsil'
    },

    UPDATE_TEHSIL: {
        path: '/edit-tehsil'
    },


    NATURE_LIST: {
        path: '/nature-list'
    },

    ADD_NATURE: {
        path: '/create-nature'
    },

    UPDATE_NATURE: {
        path: '/edit-nature'
    },


    STRUCTURE_LIST: {
        path: '/structure-list'
    },

    ADD_STRUCTURE: {
        path: '/create-structure'
    },

    UPDATE_STRUCTURE: {
        path: '/edit-structure'
    },


    CROP_LIST: {
        path: '/crop-list'
    },

    ADD_CROP: {
        path: '/create-crop'
    },

    UPDATE_CROP: {
        path: '/edit-crop'
    },


    BIO_MASTER_LIST: {
        path: '/bio-master-list'
    },

    ADD_BIO_MASTER: {
        path: '/create-bio-master'
    },

    UPDATE_BIO_MASTER: {
        path: '/edit-bio-master'
    },


    DISEASE_MASTER_LIST: {
        path: '/disease-master-list'
    },

    ADD_DISEASE_MASTER: {
        path: '/create-disease-master'
    },

    UPDATE_DISEASE_MASTER: {
        path: '/edit-disease-master'
    },


    STAGE_LIST: {
        path: '/stage-list'
    },

    ADD_STAGE: {
        path: '/create-stage'
    },

    UPDATE_STAGE: {
        path: '/edit-stage'
    },


    REQUEST_TYPE_LIST: {
        path: '/request-type-list'
    },

    ADD_REQUEST_TYPE: {
        path: '/create-request-type'
    },

    UPDATE_REQUEST_TYPE: {
        path: '/edit-request-type'
    },
}

export default accessMaster;